export enum RewardsType {
  Dollars = '$',
  Percent = '%',
}
